import Vue from "vue";
import Toast, { POSITION, TYPE } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import EosToastType from "../model/EosToastType";

const timeout = 2000
const options = {
  // default options
  timeout: timeout,
  position: POSITION.TOP_RIGHT
};

Vue.use(Toast, options);

Vue.prototype.$EosToast = {
  show({ timer = timeout, msg = "" ,type = EosToastType.default}) {
    let option = { timeout: timer }
    switch (type) {
      case EosToastType.info:
        option.type = TYPE.INFO
        break;
      case EosToastType.warning:
        option.type = TYPE.WARNING
        break;
      case EosToastType.success:
        option.type = TYPE.SUCCESS
        break;
      case EosToastType.error:
        option.type = TYPE.ERROR
        break;
      case EosToastType.default:
        option.type = TYPE.DEFAULT
        break;
    }
    Vue.$toast(msg, option);
  }
}
/**
 * Documantation:
 * https://github.com/Maronato/vue-toastification/tree/main#usage
 */